import { useAuth } from '../lib/auth'
import { formatDateTime } from '../lib/format'

// Baked in by vite.config.ts's `define` at build time -- the moment this
// specific bundle was built, not the moment a visitor's browser loaded it.
declare const __BUILD_TIMESTAMP__: number

// Test-only: only ever renders on test.getremindloop.com, so there is no
// way for this to show up on the real production site regardless of the
// deploy pipeline in use -- a hostname check rather than a build-time
// flag, since prod and test currently share the same build process.
//
// Admin-gated (2026-09-26, portal usability review item 1, user-decided):
// a build timestamp + commit hash is deploy metadata for RemindLoop's own
// team, not something a regular customer needs to see. Also moved from a
// full-width bar centered over the bottom of the viewport to a small
// bottom-right corner badge -- the old placement sat directly on top of
// list rows and KPI values at phone width on every page (Dashboard, Reminders,
// Analytics, Message Templates), since a `position: fixed` overlay has no
// layout footprint of its own to push content clear of. A corner badge
// still can't collide with primary content the way a full-width bar did.
export function BuildBadge() {
  const { user, isImpersonating } = useAuth()

  if (!window.location.hostname.startsWith('test.')) {
    return null
  }
  if (!user?.is_system_admin || isImpersonating) {
    return null
  }

  const buildDate = new Date(__BUILD_TIMESTAMP__)
  const formatted = formatDateTime(buildDate)

  return (
    <div className="pointer-events-none fixed bottom-2 right-2 z-50">
      <span className="pointer-events-auto rounded-sm bg-foreground/80 px-2 py-0.5 font-mono text-[10px] tracking-wide text-background">
        Build {formatted} · #{Math.floor(__BUILD_TIMESTAMP__ / 1000)}
      </span>
    </div>
  )
}
